import { Component, Input } from '@angular/core';
import MessagesActionsService from '../services/messages-actions.service';
import { hiddenElementSlideInOut } from '../animations/slides.animation';
import { CommonInfoService } from '../../cart-process/common-info.service';

declare var window: any;

@Component({
  selector: 'info-ccds-banner',
  templateUrl: './info-ccds-banner.component.html',
  animations: [hiddenElementSlideInOut]
})
export class InfoCcdsBannerComponent {
  @Input() infobannerdata: any;

  public isVisible = true;
  public imagePath: string = (window.themeResourcePath || '') + '/images/checkout/cart-multiSim/callcenter_woman.png';
  public isVirginBrand: boolean;

  constructor(
    private messagesActionsService: MessagesActionsService,
    private commonInfo: CommonInfoService
  ) {
    this.isVirginBrand = this.commonInfo.isVirginBrand;
  }

  removeMessage(event: Event): void {
    event.preventDefault();

    this.messagesActionsService.deleteMessage(this.infobannerdata.uid);
    this.isVisible = false;
  }
}




